<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect
        :is-picked-facility="true"
        :hide-select-one="true"
      ></BaseFacilitySelect>
    </div>
    <div>
      <div class="card">
        <div class="card-header">
          <strong>RespSafe report module</strong>
        </div>
        <div class="card-body">
          <div>
            <p>
              Follow the module below to enter numbers for your annual RespSafe report.
              Before starting the report you may find it helpful to download a current version of the
              Combined Immunization Output from the Check immunization status screen.
            </p>
            <p>
              Reports must be submitted by <b>May 15th</b> to be considered for this year’s RespSafe awards.
            </p>
          </div>
          <hr>
          <div>
            <b-form @submit.stop.prevent="submit">
              <div>
                <b-form-group id="primaryContact">
                  <b-row cols-sm="2">
                    <b-col>
                      <BaseTextInput
                        setId="primaryName"
                        v-model="submission.primaryName"
                        :v="$v.submission.primaryName"
                        slug="primaryName"
                        label="Primary RespSafe contact"
                        required
                      >
                      </BaseTextInput>
                    </b-col>
                    <b-col>
                      <BaseTextInput
                        setId="primaryEmail"
                        v-model="submission.primaryEmail"
                        :v="$v.submission.primaryEmail"
                        slug="primaryEmail"
                        label="Primary RespSafe contact email"
                        required
                      >
                      </BaseTextInput>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row class="justify-content-md-start">
                    <b-col id='test' cols="5"><label for="numEmployeesFlu">Number of employees who have received influenza vaccine this season:</label> </b-col>
                    <b-col md="1">
                      <b-form-input
                        setId="numEmployeesFlu"
                        v-model="submission.numEmployeesFlu"
                        :v="$v.submission.numEmployeesFlu"
                        slug="numEmployeesFlu"
                        aria-label="Number of employees who have received influenza vaccine this season"
                        required
                      >
                      </b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-md-start">
                    <b-col cols="5"><label for="numEmployeesCovid">Number of employees who have received covid vaccine this season:</label></b-col>
                    <b-col sm="1">
                      <b-form-input
                        setId="numEmployeesCovid"
                        v-model="submission.numEmployeesCovid"
                        :v="$v.submission.numEmployeesCovid"
                        slug="numEmployeesCovid"
                        aria-label="Number of employees who have received covid vaccine this season"
                        required
                      >
                      </b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-md-start">
                    <b-col cols="5"><label for="numEmployeesTotal">Total number of employees in the organization:</label></b-col>
                    <b-col sm="1">
                      <b-form-input
                        setId="numEmployeesTotal"
                        v-model="submission.numEmployeesTotal"
                        :v="$v.submission.numEmployeesTotal"
                        slug="numEmployeesTotal"
                        aria-label="Total number of employees in the organization"
                        required
                      >
                      </b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-md-start">
                    <b-col cols="5"><label for="percentageFlu">Percentage received influenza vaccine:</label></b-col>
                    <b-col sm="1">
                      <b-form-input
                        setId="percentageFlu"
                        v-model="submission.percentageFlu"
                        :v="$v.submission.percentageFlu"
                        slug="percentageFlu"
                        aria-label="Percentage received influenza vaccine"
                        disabled="disabled"
                      >
                      </b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-md-start">
                    <b-col cols="5"><label for="percentageCovid">Percentage received covid vaccine:</label></b-col>
                    <b-col sm="1">
                      <b-form-input
                        setId="percentageCovid"
                        v-model="submission.percentageCovid"
                        :v="$v.submission.percentageCovid"
                        slug="percentageCovid"
                        aria-label="Percentage received covid vaccine"
                        disabled="disabled"
                      >
                      </b-form-input>
                    </b-col>
                  </b-row>
                </b-form-group>
                <div>
                  <b-button class="d-block p-2 bg-mdh text-white" size="md" @click="submit">Submit</b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>

import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import {maxLength, numeric, required} from "vuelidate/lib/validators";
import axios from "axios";
import router from "@/router";

export default {
  name: 'respSafeSubmissionConfirmation',
  components: {BaseTextInput, BaseFacilitySelect},
  data: () => ({
    submission: {
      registration: '',
      facility: '',
      primaryName: '',
      primaryEmail: '',

      numEmployeesFlu: '',
      numEmployeesCovid: '',
      numEmployeesTotal: '',

      percentageFlu: '',
      percentageCovid: '',

      reportDate: new Date(),

      org: '',
    },
    registration: '',
    emailSubmission: {
      email: ' '
    },
  }),

  watch: {
    'submission.numEmployeesFlu'() {
      this.submission.numEmployeesFlu = this.submission.numEmployeesFlu.replace(/,/g, '')

      if (this.submission.percentageFlu !== '') {
        let percentage = (this.submission.numEmployeesFlu / this.submission.numEmployeesTotal) * 100
        this.submission.percentageFlu = percentage.toFixed(2) + '%'
      }
    },
    'submission.numEmployeesCovid'() {
      this.submission.numEmployeesCovid = this.submission.numEmployeesCovid.replace(/,/g, '')

      if (this.submission.percentageCovid !== '') {
        let percentage = (this.submission.numEmployeesCovid / this.submission.numEmployeesTotal) * 100
        this.submission.percentageCovid = percentage.toFixed(2) + '%'
      }
    },
    'submission.numEmployeesTotal'() {
      this.submission.numEmployeesTotal = this.submission.numEmployeesTotal.replace(/,/g, '')

      if (this.submission.numEmployeesTotal !== '') {
        this.submission.percentageFlu = ((this.submission.numEmployeesFlu / this.submission.numEmployeesTotal) * 100).toFixed(2) + '%'
        this.submission.percentageCovid = ((this.submission.numEmployeesCovid / this.submission.numEmployeesTotal) * 100).toFixed(2) + '%'
      } else {
        this.submission.percentageFlu = ''
        this.submission.percentageCovid = ''
      }
    },
  deep: true
  },

  validations() {
    return {
      submission: {
        org: { required },
        facility: { required },
        primaryName: { required, maxLength: maxLength(75) },
        primaryEmail: { required, maxLength: maxLength(75) },

        numEmployeesFlu: { required, maxLength: maxLength(10) },
        numEmployeesCovid: { required, maxLength: maxLength(10) },
        numEmployeesTotal: { required, maxLength: maxLength(10) },

        percentageFlu: { required, maxLength: maxLength(10) },
        percentageCovid: { required, maxLength: maxLength(10) },

      },
    }
  },

  created() {
    this.getRegistration()
  },

  methods: {
    getRegistration() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/respsafe/registration/${this.$store.state.selectedFacility.id}`)
        .then(response => {
          if (response.status === 200) {
            this.registration = response.data[0]
            this.submission.registration = this.registration
            this.submission.facility = this.registration.facility
            this.submission.org = this.registration.org
            this.submission.primaryName = this.registration.primaryName
            this.submission.primaryEmail = this.registration.primaryEmail
          }
        })
    },
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if ((this.registration.primaryName !== this.submission.primaryName) || (this.registration.primaryEmail !== this.submission.primaryEmail)) {
          // update primary contact info if changed
          this.registration.primaryName = this.submission.primaryName
          this.registration.primaryEmail = this.submission.primaryEmail
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/respsafe/registration/submit`, this.registration)
            .then(response => {
              if (response.status === 200) {
                this.showRootToast('Success', 'Primary RespSafe contact updated.', 'success')
              }
            })
        }
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/respsafe/report/submit`, this.submission)
          .then(response => {
            if (response.status === 200) {
              this.emailSubmission.email = this.submission.primaryEmail
              axios.post(`${process.env.VUE_APP_API_BASE_URL}/respsafe/report/email`, this.emailSubmission)
                .then(response => {
                  if (response.status === 200) {
                    router.push('/respSafeReportConfirmation')
                  }
                })
            } else {
              this.showRootToast('Error', 'Error submitting request.', 'danger')
            }
          })
      } else if (this.$v.submission.$invalid) {
        this.showRootToast('Error', 'Please fix form errors.', 'danger')
      }
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
  }
}
</script>

<style scoped>

</style>
